export const phrases = {
  heading_settings_sort: "A személyzeti lista rendezése",
  body_settings_sort: "Rendezze a személyzet listáját vezetéknév vagy keresztnév szerint.",
  since_o_clock: "Mivel {time} óra",
  old_data_warning_my_area: "Nem tudtunk új információt betölteni. Győződjön meg róla, hogy csatlakozik az internethez.",
  no_data_warning_my_area: "Győződjön meg róla, hogy csatlakozik az internethez, és próbálja meg újra.",
  no_data_available_my_area: "Nem tölthető be adat",
  last_update_data: "Utolsó frissítés",
  something_went_wrong_absences: "Valami rosszul sült el. Kérjük, próbálja meg később újra.",
  something_went_wrong_with_the_pin_entry: "Valami elromlott a PIN-kód bevitelével...",
  pin_must_be_four_digits: "A PIN-kódnak pontosan négy számjegyből kell állnia.",
  pins_do_not_match: "A megadott PIN-kódok nem egyeznek.",
  pin_is_not_numerical: "A PIN-kód csak számokból állhat.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Stamp out",
  finish_break: "Szünet vége",
  finish_loading_time: "Betöltési idő vége",
  finish_driving_time: "Vezetési idő vége",
  finish_business_trip: "A szolgálati út vége",
  finish_project_as_task: "Projekt befejezése",
  finish_special_one: "Vége Special1",
  finish_special_two: "Vége Special2",
  you_clockout: "Eltaposod magad.",
  sentence_work_time: "Dolgozol. | Most is dolgozol.",
  sentence_break: "Szünetet tartasz. | Szünetet tartasz.",
  sentence_loading_time: "Ön jelenleg a betöltési időt rögzíti. Hauruck! | Ön jelenleg a betöltési időt rögzíti. Bunkó!",
  sentence_business_trip: "Bejelentkezett szolgáltatás. Jó szórakozást!",
  sentence_driving_time: "A vezetési időt foglalja le. Öveket becsatolni és indulás! | Ön utazási időt foglal. Öveket becsatolni és indulni!",
  sentence_special_one: "Ön a Special 1 foglalása. | Ön a Special 1.",
  sentence_special_two: "Ön a Special 2-t foglalja le. | Ön a Special 2.",
  sentence_custom_time: "Ön foglal | Ön foglal",
  you_are_booked_in_activity: "Bélyegezd meg a {activity}! | Ön bélyegző {activity}!",
  substitute_warning: "{ days } A több napos vagy annál hosszabb távollét esetén helyettesítőt kell kijelölni.",
  substituted_by: "Képviseli",
  name_clocked_in: "{name} pecsétes",
  /************************************/
  //Signature stuff:

  signature: "Aláírás",
  please_sign: "Kérjük, írja alá",
  signature_with_date: "Aláírás a {date}címről",
  signature_with_date_with_name: "A {date} aláírása a {name}címről:",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "A {date} aláírása a {name} honlapról a {location}oldalon.",
  signature_with_name: "A {name}aláírása",
  signature_with_name_with_location: "A {name} aláírása a {location}oldalon.",
  signature_with_location: "Aláírás a {location}oldalon.",
  /*************************************/

  accept_terms_and_conditions: "Az űrlap elküldésével Ön elfogadja a {agb} és a {datenschutzerklaerung}címünket.",
  what_is_your_name: "Hogy hívnak?",
  your_email: "Az Ön e-mail címe",
  what_is_your_company_name: "Mi a cég neve?",
  what_do_you_want_to_do_with_clockin: "Mit akarsz csinálni az óramutató járásával?",
  almost_finished: "Majdnem ott vagyunk",
  test_clockin_for_amount_period: "Tesztelje a {amountOfDaysTestPeriod} ingyenesen néhány napig!",
  code_needed_to_connect: "Használja a kódját",
  you_have_no_company_code: "Nincs kódja? Vegye fel a kapcsolatot a vállalatánál dolgozó személlyel.",
  connect_your_device: "Csatlakoztassa a készülékét!",
  please_type_in_device_id: "Kérjük, adja meg a készülék azonosítóját, amelyet a weboldalunkon a mobileszközök között talál.",
  new_at_clockin: "Új az óraadásban?",
  pin_repeat: "Ismételje meg a PIN-kódot",
  configure_your_pin: "Állítsa be a 4 számjegyű PIN-kódot",
  configure_your_pin_text: "A PIN-kódra a tablet terminálon lévő személyes területéhez való hozzáféréshez van szükség.",
  congratulations: "Gratulálunk!",
  start_now: "Kezdje el most",
  device_name_info: "Megváltoztathatja a mobileszköz eszköznevét, így több eszközt is nyomon követhet. Példa: \"Smartphone MaxMustermann\". A név később is módosítható.",
  select_project: "Projekt kiválasztása",
  select_time: "Kiválasztott időpont",
  create_new_account: "Új fiók létrehozása",
  join_my_company: "Csatlakozz a cégemhez",
  join_clockin_with_qr: "Csatlakozás QR-kóddal",
  change_project: "Változás projekt",
  my_messages: "Az én híreim",
  my_documents: "Dokumentumaim",
  my_data_and_passwords: "Adataim és jelszavaim",
  my_account_data: "Az én adataim",
  change_my_password: "Jelszó módosítása",
  forgot_password: "Nem tudom a jelszavamat.",
  open_camera: "Nyitott kamera",
  scan_now: "Szkennelés most",
  sync_now: "Szinkronizálás most",
  clear_logs: "Üres naplók",
  saveAndGoBack: "Mentés és visszatérés",
  full_day: "Egész nap",
  activate_scanner: "A szkenner aktiválva van",
  scanner_is_inactive: "A szkenner inaktív",
  change_project_by_scan_qr: "Szkennelje be a váltani kívánt projekt QR-kódját.",
  scan_device_by_qr: "Szkennelje be a QR-kódot a használni kívánt eszközről.",
  no_access_to_camera_please_connect_device_manually: "Sajnos a kamerához nem sikerült hozzáférni, kérjük, adja meg a készülék kódját kézzel.",
  no_access_to_camera_please_clockin_manually: "Sajnos, nem volt lehetséges a kamerához való hozzáférés, kérjük, kézzel bélyegezzen be.",
  qr_code_login: "QR-kód regisztráció",
  scan_to_login: "A bejelentkezéshez szkennelje be a QR-kódot.",
  checklist_was_saved: "Az ellenőrzőlista el lett mentve",
  question_save_changes_short: "Változások mentése?",
  question_save_changes: "Szeretné elmenteni a változtatásokat?",
  question_delete_checklist_short: "Ellenőrző lista törlése?",
  question_delete_checklist: "Biztos, hogy törölni szeretné az ellenőrzőlistát?",
  checklist_is_sending: "Ellenőrző lista küldésre kerül",
  checklist_sent_successfully: "Az ellenőrzőlista sikeresen 🎉 elküldve",
  checklist_could_not_be_sent: "Az ellenőrzőlista nem küldhető el, kérjük, próbálja újra később.",
  checklist_transmission_problems_in_the_past: "A múltban egyes fájlokkal kapcsolatban átviteli problémák merültek fel.",
  checklist_send_with_potential_data_loss: "Szeretné megpróbálni elküldeni az ellenőrzőlistát ezen fájlok nélkül?",
  documentation_is_sending: "A projektdokumentációt elküldik",
  documentation_sent_successfully: "Projekt dokumentáció sikeresen elküldve 🎉",
  confirm_documentation_dismissal: "Tényleg el akarja dobni a dokumentációt?",
  discard_unsaved_changes: "Szeretnéd eldobni a változtatásokat?",
  documentation_will_be_sent_when_online: "A dokumentációt elküldjük, amint újra online leszel.",
  confirmation_is_sending: "A projekt visszaigazolása elküldésre kerül",
  ask_for_geo_permission: "Ennek az alkalmazásnak szüksége van a helyére, " + "de nincs engedélye erre.\n\n" + "Meg szeretné nyitni a beállításokat?",
  all_projects: "Minden projekt",
  half_day: "Fél nap",
  start_end: "Idő szerint",
  my_area: "Az én területem",
  my_area_video_teaser_clockin_explained_by_frederik: "Clockin magyarázatát Freddi",
  add_time: "Idő létrehozása",
  show_times_in_confirmation: "Mutasd meg a visszaigazolásban szereplő időpontokat",
  change_time: "Változási idő",
  finish_project: "Teljes projekt",
  finish_project_date: "A kinevezés véglegesítése",
  unfinish_project: "Projekt újranyitása",
  unfinish_project_date: "Újra megnyitni a kinevezést",
  absence_overview: "Kezelje a hiányzásokat",
  edit_absence: "Szerkesztés hiánya",
  edited_absence: "Szerkesztett távollét",
  created_absence: "Sikeresen létrehozott távozási kérelem",
  creating_absence: "A szabadságkérelmét mostantól létrehozzuk",
  error_creating_absence: "Hiba a távolléti kérelem létrehozásakor",
  create_absence: "Távollét létrehozása",
  deleted_absence: "Visszavont távollét iránti kérelem",
  new_request: "Új alkalmazás",
  your_requests: "Az Ön alkalmazásai",
  planned_days: "Tervezett napok",
  planned_hours: "Ütemezett órák",
  used_days: "Felhasznált napok",
  used_hours: "Eltöltött órák száma",
  free_days: "Szabadnapok",
  free_hours: "Szabadság nyitvatartási ideje",
  open_days: "Nyílt napok",
  open_hours: "Nyitva tartás",
  withdraw_request: "Visszavonja a kérelmet",
  change_request: "Változtatási kérelem",
  request_was_approved: "Az Ön kérelmét jóváhagyták",
  request_is_pending: "Az Ön jelentkezését még nem hagyták jóvá",
  request_was_rejected: "Az Ön jelentkezését elutasították",
  add_attachment: "Melléklet hozzáadása",
  message_optional: "Üzenet (nem kötelező)",
  filed_on: "Beküldte",
  this_year: "Idén",
  search_sub_projects: "Melyik alprojektben szeretne dolgozni?",
  error_occurred: "Hiba történt, próbálkozzon újra később.",
  re_record: "Törölni és újravenni ezt a videót?",
  delete_video: "Törölni a felvételt?",
  no_results_found: "Nincs eredmény",
  record_again: "Újra",
  request_valid_email: "Kérjük, adjon meg egy érvényes e-mail címet.",
  request_valid_company_name: "Kérjük, adjon meg egy érvényes cégnevet.",
  request_valid_first_name: "Kérjük, adjon meg egy érvényes keresztnevet.",
  request_valid_last_name: "Kérjük, adjon meg egy érvényes vezetéknevet.",
  total_duration_today: "Teljes idő ma",
  show_daily_protocol: "Napi napló megjelenítése",
  change_profile_pic: "Profilkép módosítása",
  logout_account: "Fiók lekapcsolása",
  you_are_working: "Most éppen dolgozol!",
  you_are_taking_a_break: "Szünetet tartasz!",
  activity_edited: "Szerkesztett tevékenység",
  activity_edited_undo: "Feldolgozás sikeresen visszavonva",
  activity_edited_missing_project: "Ó, a projekt még mindig hiányzik!",
  activity_deleted: "Tevékenység törölve",
  activity_deleted_undo: "Törölt tevékenység visszaállítása",
  activity_created: "Új tevékenység létrehozása",
  activity_created_undo: "Újonnan létrehozott tevékenység visszavonva",
  correct_working_hours: "Helyes munkaidő",
  your_changes_are_being_saved: "A módosítások mostantól mentésre kerülnek.",
  manage_working_hours: "Munkaidő kezelése",
  delete_activity: "Tevékenység törlése",
  start_navigation: "Navigáció indítása",
  no_valid_email: "A megadott e-mail cím nem érvényes.",
  delete_checklist: "Ellenőrző lista törlése",
  active_checklists: "Aktív ellenőrző listák",
  scan_qr_code: "QR-kód beolvasása",
  switch_to_office_center: "Váltson az irodaközpontra",
  confirm_project_completion_short: "Teljes projekt",
  confirm_project_date_completion_short: "A kinevezés véglegesítése",
  project_completed: "Projekt befejezve!",
  project_date_completed: "A kinevezés véglegesítve!",
  confirm_project_uncompletion_short: "Projekt újranyitása",
  confirm_project_date_uncompletion_short: "Újra megnyitni a kinevezést",
  project_uncompleted: "Aktivált projekt",
  project_date_uncompleted: "Aktiválás dátuma",
  choose_project: "Projekt kiválasztása",
  choose_sub_project: "Alprojekt kiválasztása",
  choose_site: "Helyszín kiválasztása",
  active_projects: "Aktív projektek",
  completed_term: "elkészült",
  completed_projects: "Befejezett projektek",
  end_of_work: "Kellemes estét kívánok",
  correct_time: "Helyes idő",
  you_stamp_x: "Te bélyegezel",
  enter_pin: "Kérjük, adja meg a PIN kódot",
  wrong_pin: "Helytelen PIN-kód bevitele",
  pin_change_required: "Önt felszólították a PIN kód megváltoztatására",
  enter_new_pin: "Új PIN-kód megadása",
  approve_pin: "PIN megerősítése",
  no_projects_scheduled: "Részére {day} Projekteket nem tárolnak.",
  you_clock_in_project: "Mostantól kezdve rögzíti a projekt munkaidejét.",
  project_scan_error: "Ez a kód nem érvényes egyetlen projektre sem.",
  show_more_days: "további napok megjelenítése",
  show_more_times: "További időpontok megjelenítése",
  only_show_today: "Csak ma mutasd meg",
  todays_total_time: "Teljes idő ma",
  everything_synced: "Az Ön adatai naprakészek!",
  upload_in_progress: "Az adatok feltöltése...",
  who_are_you: "Ki vagy?",
  is_uploading_to_server: "Az Ön módosításait az irodai központba továbbítjuk.",
  offline_and_data_is_stored_locally: "A módosítások hamarosan átkerülnek az irodaközpontba. ",
  show_more: "mutass többet",
  activity_edited_wrong_date: "Rossz dátumot írt be.",
  confirm_logout: "Tényleg le akarsz iratkozni?",
  confirm_clockout: "Biztos, hogy mára ki akarsz menni?",
  gps_is_active: "A GPS-adatokat továbbítják",
  location_tracking_is_active: "GPS-követés engedélyezése.",
  app_settings: "Alkalmazás beállításai",
  clock_reminder: "Bélyeg - Emlékeztető",
  mon_to_fri: "Standard: hétfőtől péntekig",
  logout: "Fiók lekapcsolása",
  refresh: "Frissítés",
  prompt_language_settings: "Itt állíthatja be az alkalmazás nyelvét.",
  prompt_clock_reminder: "Emlékeztető push értesítéssel, hogy illeszkedjen a mindennapi munkádhoz.",
  register_company: "Regisztráljon céget",
  use_code: "Használja a kódot",
  our_customers: "Ügyfeleink",
  free_test_now: "Teszt most ingyenesen",
  tier_attendance: "Csak a munkaidőt és a szüneteket rögzítem.",
  tier_documentation: "Szeretnék munkaórákat is könyvelni az általam kezelt projektekre az órabeállításban.",
  your_tier: "Az Ön csomagja",
  all_clockin_functions: "Minden clockin funkció",
  checklists_formulars: "Ellenőrző listák és funkciók",
  projectfile_incl_chat: "Digitális projektfájlok (beleértve a chatet)",
  photo_sketch_note: "Fotó, vázlat és jegyzet funkció",
  digital_signature: "Digitális aláírások",
  datev_connection: "DATEV kapcsolat",
  calendar_absences: "Naptár és hiányzások kezelése",
  individual_design: "Egyéni megjelenés",
  attendance_time_tracking: "Helyhez kötött időfelvétel tablet terminálon keresztül",
  mobile_time_tracking: "Mobil időfelvétel okostelefonos alkalmazáson keresztül",
  browser_time_tracking: "Böngészőidő-felvétel a PC-n az otthoni irodában",
  help_use_code: "Kérjük, adja meg az irodaközpontban a mobileszközök/munkavállalók menüpontban található kódot.",
  wrong_code: "Rossz kód",
  wrong_code_text: "A kód nem érvényes. Kérjük, próbálja meg újra érvényes kóddal",
  wrong_code_text_short: "A kód érvénytelen",
  clockin_logo: "Clockin logó",
  invalid_qr_code: "Érvénytelen QR-kód",
  invalid_qr_code_text: "A beolvasott QR-kód érvénytelen. Kérjük, olvassa be az érvényes clockin kódot.",
  code_already_connected: "Ezzel a kóddal csatlakoztathatja készülékét. De már csatlakoztatva van.",
  wrong_credentials: "Helytelen hozzáférési adatok",
  wrong_credentials_text: "A megadott e-mail és jelszó kombináció nem található. Kérjük, ellenőrizze a bejegyzést, és próbálja meg újra.",
  new_pin: "Új PIN-kód megadása",
  choose_next_action: "Válassza ki a következő műveletet",
  name_of_software_package: "A szoftvercsomag neve",
  select_teamleader: "Ki bélyegez a csapatért?",
  select_teamleader_description: "A bélyegzési tevékenység folytatásához kérjük, válasszon ki egy személyt, aki most átveszi a gépet.",
  clocked_in_on_this_device: "Bélyegzővel ellátva ezen az egységen",
  not_clocked_in_on_this_device: "Ezen az egységen nincs bélyegző",
  select_new_teamleader: "Kinek kellene most a csapatért bélyegeznie?",
  switch_teamleader: "Egység átadása",
  just_me: "Épp most léptem ki.",
  select_the_new_teamleader: "Az új csoportvezető meghatározása",
  back_to_selection: "vissza a válogatáshoz",
  manage_team: "Csapat irányítása",
  total_time_team: "A csapat teljes ideje",
  count_members_clocked_in: "{clockedin}/{members} Csapattagok bélyegzővel ellátva",
  whole_team: "Az egész csapat",
  teammembers_still_clockedin: "Válaszd ki, hogy csak magadat vagy a csapat minden tagját szeretnéd leütni?",
  clockout_all: "Ki kell irtani minden",
  select_employee: "Először válasszon ki egy felhasználót",
  something_went_wrong: "Valami rosszul sült el, kérjük, próbálja meg később újra.",
  new_pin_successfully_changed: "A PIN kód sikeresen megváltozott",
  enter_pin_before_clockin_prompt: "Először adja meg egyesével a PIN-kódját a bejelentkezéshez.",
  enter_pin_before_clockout_prompt: "Először adja meg egyesével a PIN-kódját a kijelentkezéshez.",
  delete_activity_alert_title: "Tevékenység törlése",
  delete_activity_alert_msg: "Biztos, hogy törölni szeretné a tevékenységet?",
  delete_absence_message: "Biztos, hogy vissza akarja vonni a jelentkezését?",
  delete_absence_title: "Visszavonja a kérelmet",
  are_you_sure: "Biztos vagy benne?",
  request_password: "Új jelszó kérése",
  password_requested: "Az új jelszóhoz szükséges linket elküldtük az Ön e-mail címére.",
  no_email_retrieved: "Nem kapott e-mailt? Kérjük, ellenőrizze a spam mappát, vagy próbálja meg újra.",
  name_of_customer: "Az ügyfél neve",
  missing_permissions_homepage_text: "Nincs jogosultsága a tevékenységének módosítására ezen a gépen. Kérjük, lépjen kapcsolatba a rendszergazdával a hozzáférés megszerzéséhez.",
  no_permission_warning_my_area: "Nincs jogosultsága ehhez a területhez. Kérjük, lépjen kapcsolatba a rendszergazdával a hozzáférés megszerzéséhez.",
  employee_clocked_in: "{name} regisztrált!",
  employee_clocked_out: "{name} kijelentkezett!",
  no_employee_to_qr_code_warning: "Ehhez a QR-kódhoz nem találtak alkalmazottat.",
  no_employees_registered_heading: "Ehhez az egységhez még nem rendeltek ki személyzetet.",
  no_employees_registered_body: "Az irodaközpontban a mobileszköz beállításaiban kijelölheti az alkalmazottakat, akiknek engedélyezi, hogy ezen az eszközön rögzítsék az idejüket.",
  no_employee_found: "Sajnos senkit sem sikerült találni ezzel a névvel.",
  no_employee_assigned: "Nem jelölt ki alkalmazottat",
  you_need_help: "Segítségre van szüksége?",
  here_you_can_get_help_to_register_employees_for_device: "Itt talál minden információt arról, hogy hogyan rendelheti a személyzetet egy egységhez.",
  show_time: "Idő létrehozása",
  export_timesheet: "Munkaidő-nyilvántartás exportálása",
  select_month: "Válassza ki a hónapot",
  internet_connection_required: "Ehhez internetkapcsolat szükséges.",
  select_an_activity_to_clockin_your_team: "Válasszon ki egy tevékenységet, amelyet a csapatában le kell bélyegezni.",
  confirm_uploading_sqlite_for_debugging: "Biztos, hogy a Clockin-támogatáshoz az alkalmazásban szeretné feltölteni az adatokat?",
  no_tasks_available: "Nincsenek feladatok",
  click_to_add_tasks: "Kattints a feladatok hozzáadásához",
  scan_nfc_tag: "Kérjük, tartsa a kártyát az olvasó felé.",
  link_nfc_tag: "Link NFC címke",
  select_employee_for_nfc_tag: "Kérjük, válasszon ki egy alkalmazottat az NFC címke összekapcsolásához:",
  nfc_tag_linked_successfully: "NFC címke sikeresen {name} Kapcsolódó.",
  nfc_linking_failed: "Az NFC-címke nem kapcsolható össze. Kérjük, próbálja újra.",
  nfc_not_enabled: "Ez az eszköz nem támogatja az NFC-t, vagy le van tiltva.",
  nfc_initialization_failed: "Sajnos valami elromlott. Kérjük, próbálja újra.",
  nfc_scan_failed: "Sajnos valami elromlott. Kérjük, próbálja újra.",
  nfc_no_tag_found: "Nem található NFC címke.",
  nfc_tag_already_linked_to: "Ez az NFC-címke már elérhető a következőkkel: {name} Kapcsolódó.",
  nfc_scan_active: "NFC-vizsgálat aktív",
  nfc_linking_enabled: "Az NFC-címkék mostantól összekapcsolhatók. Kérjük, tartsa az NFC-címkét, hogy most összekapcsolja az NFC-olvasóval.",
  nfc_all_employees_linked: "Az eszközhöz rendelt összes alkalmazott már össze van kapcsolva.",
  no_employee_to_nfc_warning: "Ehhez az NFC-címkéhez nem találtak alkalmazottat.",
  select_employee_to_link_nfc: "Kihez kell kapcsolni az NFC-címkét?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Üdvözlünk az órán.",
        clocking_time: "Pályaidők",
        push_notifications: "Ne felejtsd el semmit"
      },
      text: {
        clocking_time: "Az órázó minden tevékenységhez a kiindulópont. Te intézed a munkádat, az alkalmazás a dokumentációt is.",
        push_notifications: "Most kapcsold be az értesítéseket. Clockin emlékeztet, ha elfelejtesz egy bélyeget, és gondoskodik róla, hogy minden fontos azonnal megkapja."
      },
      button: {
        lets_go: "Kezdje el most"
      }
    },
    my_area: {
      heading: {
        my_area: "Az én területem",
        absences: "Távollétek és kérelmek",
        settings: "Személyes beállítások"
      },
      text: {
        my_area: "A központi hely, ahol azonnal áttekintheti munkaidejét és túlóráit. Innen kezelheti munkaidejét, hozzáférhet napi naplójához, kérvényeket nyújthat be és megtekintheti munkaidejét.",
        absences: "Kezelje a szabadságkérelmeket, betegszabadságokat és egyéb távolléteket. Mindig nyomon követheti a kérelmek státuszát, és néhány kattintással gyorsan és egyszerűen nyújthat be új kérelmeket.",
        settings: "Küldjön üzenetet a vállalatnak, vagy módosítsa személyes beállításait, és ha jelszavát szeretné megváltoztatni, azt is itt teheti meg!"
      },
      button: {
        lets_go: "Kezdj el"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Mert az Ön ideje számít",
        clock_in: "Stamp in",
        switch_task: "Bélyegváltás",
        clock_out: "Stamp out",
        thats_it: "Ez az!"
      },
      text: {
        your_time_matters: "A clockin segítségével segítünk Önnek a lényeges dolgokra koncentrálni. Rögzítse munkaidejét egyetlen kattintással.",
        clock_in: "Egyetlen kattintással közvetlenül be van iktatva. A Clockin automatikusan elmenti az adatait, és így mindig mindent szem előtt tarthat.",
        switch_task: "Újabb projektje van, szünetet tart, vagy a következő találkozója felé tart? Egyszerűen bélyegezd át magad az új tevékenységedre. A többi automatikusan rögzítésre kerül.",
        clock_out: "És egy kattintással ki is bélyegzik.",
        thats_it: "Megcsinálta, és készen áll a munkaidő nyilvántartására. Ha segítségre van szüksége, csak lépjen kapcsolatba velünk. Az órabeállítással minden egyszerű - beleértve a velünk való kommunikációt is."
      },
      button: {
        your_time_matters: "Mutasd meg, hogyan kell csinálni",
        thats_it: "Kezdje el most"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Mert az Ön ideje számít",
        clock_in: "Stamp in",
        clock_in_team: "Bejelentkező csapat",
        switch_task: "Bélyegváltás",
        change_teamleader: "Egység átadása",
        clock_out: "Stamp out",
        thats_it: "Ez az!"
      },
      text: {
        your_time_matters: "A clockin segítségével segítünk Önnek a lényeges dolgokra koncentrálni. Rögzítse csapata munkaidejét egyetlen kattintással.",
        clock_in: "Válassza ki azt a személyt, aki a csapat számára órát ad, és egyetlen kattintással közvetlenül be van órázva. Az clockin automatikusan elmenti az adatokat, így mindig szemmel tarthat mindent.",
        clock_in_team: "Egyszerűen csak bélyegezd meg a csapatodat közvetlenül. Akár mindannyian egyszerre, akár csak egyes tagok.",
        switch_task: "Másik projektje van, szünetet tart, vagy éppen a következő találkozójára utazik? Egyszerűen bélyegezze le az új tevékenységét. A többi automatikusan rögzítésre kerül.",
        change_teamleader: "Befejezed a munkát, el kell menned, vagy már nem jársz be a csapathoz? Egyszerűen adja át a készüléket az alkalmazásban, és minden visszatér a régi kerékvágásba.",
        clock_out: "És egyetlen kattintással Ön és csapata is kimerül. Természetesen az egyes tagokat is bármikor kiórázhatja.",
        thats_it: "Megcsinálta, és készen áll a csapat munkaidejének rögzítésére. Ha segítségre van szüksége, csak lépjen kapcsolatba velünk. Az órabeállítással minden egyszerű - beleértve a velünk való kommunikációt is."
      },
      button: {
        your_time_matters: "Mutasd meg, hogyan kell csinálni",
        thats_it: "Kezdje el most"
      }
    },
    my_area: {
      heading: {
        welcome: "Üdvözöljük az Ön területén",
        my_area: "Az én területem",
        create_time: "Idő létrehozása",
        change_time: "Helyes idő",
        absences: "Távollétek és kérelmek",
        settings: "Személyes beállítások",
        thats_it: "Ez az!"
      },
      text: {
        welcome: "Fedezzen fel még több lehetőséget a munkaidő hatékony és egyszerű kezelésére. Vessünk egy pillantást az Ön területére.",
        my_area: "A központi hely, ahol azonnal áttekintheti munkaidejét és túlóráit. Innen kezelheti munkaidejét, hozzáférhet napi naplójához, kérvényeket nyújthat be és megtekintheti munkaidejét.",
        create_time: "Elfelejtett megadni egy időpontot, vagy később szeretne időpontokat hozzáadni? Semmi gond! Adja hozzá a hiányzó időket, rögzítse a szüneteket, és tartsa naprakészen munkaidő-számláját.",
        change_time: "Szeretnéd korrigálni az idődet? Semmi gond! A clockin segítségével könnyedén korrigálhatja és beállíthatja a hibás időket.",
        absences: "Kezelje a szabadságkérelmeket, betegszabadságokat és egyéb távolléteket. Mindig nyomon követheti a kérelmek státuszát, és néhány kattintással gyorsan és egyszerűen nyújthat be új kérelmeket.",
        settings: "Küldjön üzenetet a vállalatnak, vagy módosítsa személyes beállításait, és ha jelszavát szeretné megváltoztatni, azt is itt teheti meg!",
        thats_it: "Megcsináltad! Mostantól könnyedén kezelheti az idejét, megszervezheti a hiányzásokat, és arra koncentrálhat, ami fontos: a munkájára. Sok sikert a produktív időtöltéshez!"
      },
      button: {
        welcome: "Mutasd meg, hogyan kell csinálni",
        thats_it: "Kezdje el most"
      }
    },
    clock: {
      clockin_now: "Most zárd be",
      clock_your_first_time_now: "& rögzítse az első alkalommal"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Köszönjük, hogy a clockin-t használja!",
      question: "Mennyire valószínű, hogy ajánlani fogja a clockint barátainak vagy kollégáinak?",
      very_likely: "Nagyon valószínű",
      very_unlikely: "Nagyon valószínűtlen",
      help_us_improve: "Hogyan javíthatnánk az Ön számára az órabeállítást?",
      what_do_you_agree_with: "Mely állításokkal értene egyet?",
      choose_three_statements: "Válasszon legfeljebb három állítást.",
      hard_to_use: "nehezen kezelhető",
      lacking_features: "Túl kevés funkció",
      does_not_help_me: "nem könnyíti meg a munkanapomat",
      confusing: "zavaros",
      poorly_implemented: "Rosszul végrehajtott funkciók",
      too_buggy: "túlságosan hibakényes",
      too_slow: "Hosszú betöltési idők",
      what_else: "Van még valami, amit szeretne elmondani nekünk?",
      can_we_ask_you_a_few_questions: "Feltehetnénk még néhány kérdést?",
      how_happy_are_you_with_the_introduction_of_clockin: "Mennyire elégedett az óraátállítás bevezetésével a vállalatánál?",
      how_much_do_you_enjoy_using_clockin: "Hogy tetszik a clockin használata?",
      how_much_easier_does_clockin_make_your_work: "Mennyire könnyíti meg az óraátállítás a napi munkát?",
      how_happy_are_you_with_the_following_aspects: "Mennyire elégedett a következő pontokkal?",
      clarity_of_the_app: "Az alkalmazás áttekinthetősége",
      simplicity_of_use: "A működés egyszerűsége",
      app_features: "Funkciók az alkalmazásban",
      feedback_received: "Visszajelzését megkaptuk. Köszönjük, hogy időt szánt ránk.",
      thanks_for_taking_the_time: "Köszönjük, hogy időt szakított ránk.",
      what_can_we_do_to_improve: "Mesélne nekünk többet a tapasztalatairól, hogy legközelebb még jobbak lehessünk?",
      what_can_we_do_to_get_it_right: "Mesélne nekünk többet a tapasztalatairól, hogy legközelebb jobban tudjunk intézkedni?",
      comment_placeholder: "Az Ön üzenete"
    }
  },
  travel_logs: {
    add: "Utazás részleteinek hozzáadása",
    edit: "Utazási adatok szerkesztése",
    saving: "Az utazás részletei elmentésre kerülnek...",
    saved_successfully: "Az utazás adatai sikeresen elmentve!",
    unable_to_save: "Sajnos ez nem jött össze 😢."
  },
  attach_file: "Fájl csatolása",
  image_to_text: {
    info: "Győződjön meg róla, hogy a szöveg jól felismerhető és teljes egészében látható a képen.",
    attach_image: "Kép csatolása",
    processing: "A szövegét beolvassák.",
    processing_failed: "Sajnos, az importálás nem működött 😢",
    no_text_found: "Egyetlen szöveget sem lehetett felismerni."
  },
  correction_enter_reason: "Kérjük, indokolja meg a javítást.",
  daily_notes: {
    add: "Írjon egy jegyzetet",
    edit: "Megjegyzés szerkesztése",
    saving: "A jegyzet el van mentve...",
    saved_successfully: "Megjegyzés sikeresen elmentve!",
    unable_to_save: "Sajnos ez nem jött össze 😢.",
    no_notes_yet: "Nincs létrehozott jegyzet",
    create_note: "Hozzon létre"
  },
  calendar_sync: {
    title: "Ütemezés szinkronizálása",
    description: "Szinkronizálja munkarendjét egy naptárral, és tartsa szemmel a régi és új találkozókat.",
    url: "Cím iCal formátumban",
    url_description: "Ezt a címet használhatja a naptár eléréséhez más alkalmazásokból.",
    note: "Megjegyzés:",
    note_description: "Egyes naptárak esetében akár 24 óráig is eltarthat, amíg az új időpontok megjelennek.",
    sync_now: "Naptár szinkronizálása",
    copied: "Naptár url másolva."
  },
  registration: {
    skip_all: "Ugorj át mindent",
    already_signed_up: "Már van egy fiókom",
    title_1: "Kezdjük el! Mely időpontokat szeretné rögzíteni az clockinnal?",
    description_1: "Hagyja, hogy testre szabjuk az órabeállításokat az Ön számára",
    option_1_a: "Általános munkaidő (érkezés, távozás és szünet)",
    option_1_b: "Projekt munkaidő",
    title_2: "Szeretné dokumentálni?",
    description_2: "Milyen követelményeknek kell ehhez megfelelni?",
    option_2_a: "Fotók",
    option_2_b: "Vázlatok",
    option_2_c: "Megjegyzés funkció",
    option_2_d: "Ellenőrző listák és űrlapok",
    option_2_e: "Digitális projektfájlok",
    title_3: "Mit szeretne még digitalizálni?",
    description_3: "A clockinban sokkal több felfedeznivaló van, talán van valami az Ön számára.",
    option_3_a: "Nyaralás",
    option_3_b: "Betegségek és hiányzások",
    option_3_c: "Digitális személyi akták",
    option_3_d: "Vállalati elemzés",
    option_3_e: "Telepítés tervezése",
    option_3_f: "Adattovábbítási adótanácsadó (DATEV)",
    title_4: "Melyik iparágban tevékenykedik az Ön cége?",
    description_4: "Szeretnénk jobban megismerni Önt, hogy az Ön igényeihez jobban igazíthassuk az óraadást.",
    option_4_a: "szolgáltatások",
    option_4_b: "Craft",
    option_4_c: "Egészség és wellness",
    option_4_d: "Beszerzés, rendelés és kereskedelem",
    option_4_e: "Szálloda és vendéglátás",
    option_4_f: "Autó, szállítás és gépek",
    option_4_g: "Egyéb iparágak",
    title_5: "Hány alkalmazottja van a cégének?",
    description_5: "Az alkalmazottak számával az Ön vállalatának méretéhez igazíthatjuk az órabeállítást.",
    title_6: "Szuper! Az órád mostantól be van állítva",
    description_6: "Csak a nevedre van szükségünk.",
    input_6_a: "Cég",
    input_6_b: "Keresztnév",
    input_6_c: "Vezetéknév",
    input_6_d: "Telefonszám",
    title_7: "Készen állsz az indulásra! Próbálja ki 14 napig ingyenesen a clockin-t!",
    input_7_a: "Az Ön e-mail címe",
    description_7: "Melyik e-mail címre küldjük el a jelszavát?",
    input_7_b: "Így tudatosult bennem.",
    how_did_you_hear_about_clockin: "Hogyan hallottál először a clockinról?",
    recommendation_option_1: "Ajánlás",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Internetes keresés",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Összehasonlító platform",
    recommendation_option_7: "Magazin és online cikkek",
    known_from: "Ismert a",
    agb_1: "Az űrlap elküldésével Ön elfogadja a ",
    agb_2: 'AGB',
    agb_3: " és a ",
    agb_4: "Adatvédelmi szabályzat",
    start: "A teszt megkezdése",
    validation_failed: "Kérjük, töltsön ki minden mezőt helyesen."
  },
  clocki: {
    listening_heading: "Hallgatlak rád",
    listening_subtext: "Miben segíthetek?",
    hi_0: "Jó napot, miben segíthetek?",
    hi_1: "Hé, miben segíthetek?",
    hi_2: "Jó napot, miben segíthetek?",
    hi_3: "Moin moin, mit tehetek önért?",
    hi_4: "Szia, mit tehetek érted?",
    hi_5: "Jó napot, miben segíthetek?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Sajnos úgy tűnik, hogy a hangfelismerés nem működik a készülékeden.",
    microphone_permission_denied: "Sajnos, nincs hozzáférésem a mikrofonjához. Kérem, ellenőrizze a beállításoknál a jogosultságokat, hogy hallhassam Önt.",
    please_speak: "Most már beszélhetsz Clockival",
    create_activity: "Tevékenység létrehozása",
    modify_activity: "Tevékenység módosítása",
    delete_activity: "Tevékenység törlése",
    create_daily_note: "Napi jegyzet létrehozása",
    search_project: "Projekt keresése",
    note_copied: "Megjegyzés másolva",
    create_absence_request: "Hiányzás kérése",
    delete_absence: "Távollét törlése",
    confirm_deletion: "Biztos benne, hogy a {activity_label} Bélyegzés innen {date} Törölni kellene?",
    confirm_absence_deletion: "Biztos benne, hogy a {category} a {startDate} amíg {endDate} Törölni szeretné?",
    task_before_modification: "Előtt: {task}",
    starts_at_before_modification: "Kezdési időpont előtt: {startsAt}",
    ends_at_before_modification: "Befejezési időpont: {endsAt}",
    something_went_wrong: "Ó, valami elromlott, kérjük, próbálja meg később újra.",
    was_this_helpful: "Tudna Clocki segíteni?",
    actions: {
      CREATE_ABSENCE: {
        title: "Távollét megerősítése"
      },
      CREATE_DAILY_NOTE: {
        title: "Hozzon létre egy jegyzetet most",
        daily_notes_disabled: "Sajnos a jegyzet funkció ki van kapcsolva. Kérjük, kérje meg a rendszergazdát, hogy aktiválja a funkciót az irodaközpontban.",
        success: "Sikeresen elmentett jegyzet a napi naplóban 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Dokumentáció létrehozása most",
        created_by_clocki: "Létrehozva a Clocki segítségével"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Nyissa meg a \"My times\"-t most"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Nyissa meg a \"Saját területemet\" most"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Nyissa meg a \"Jelszó módosítása\" opciót most"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Bélyegző \"munkaidő\" most",
        PAUSE: "Bélyegző \"Szünet\" most",
        DRIVING_TIME: "Bélyegző \"utazási idő\" most",
        LOGOUT: "Feloldás most"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Szereted használni a Clockint?"
  },
  translation_failed: "Sajnos a fordítás nem működött 😕",
  video_transcript_not_available: "Nincs elérhető átirat",
  video_upload_succeeded: "Videófeltöltés befejeződött.",
  video_upload_failed: "Videófeltöltés sikertelen volt.",
  video_send_failed: "A videót jelenleg nem lehetett sugározni. Később újra próbálkozunk.",
  uploading_video: "Videó feltöltése...",
  language_selection_header: "Kiválasztott nyelv",
  language_selection_message: "Válaszd ki a kedvenc nyelvedet",
  shifts: {
    my_shifts: "Műszakjaim",
    free_shifts: "Szabad műszakok",
    next_shift: "A következő műszakod",
    shift_not_found: "Nem talált rétegeket",
    show_shift_plan: "Nézze meg ezt a műszakmenetrendet",
    no_shift_place: "Nincs hely megadva.",
    no_shifts_assigned: "Jelenleg nincs beosztva egyetlen műszakba sem",
    free_shifts_unavailable: "Jelenleg ingyenes műszakok nem elérhetők",
    filter_shift_plans: "Szűrő műszak ütemezések",
    no_shift_plans_available: "Nincs műszaki menetrend",
    filter_locations: "Szűrőhelyek",
    no_locations_available: "Nincs elérhető hely",
    no_plan_selected: "Nincs műszaki menetrend",
    no_shifts_for_plan: "Ehhez a tervhez nem találtak rétegeket",
    no_shifts_for_location: "A kiválasztott helyszínen nem találtak műszakokat",
    unknown_shift_plan: "Ismeretlen műszaki menetrend",
    unknown_location: "Ismeretlen helyszín",
    loading_more_shifts: "Tölts be több réteget..."
  },
  clockin_reminder_title: "Már dolgozol? 🔔",
  clockin_reminder: "Ne felejtsd el bejelentkezni.",
  clockout_reminder_title: "Már a nap végén vagy? 🔔",
  clockout_reminder: "Ne felejts el kijelentkezni.",
  choose_clockin_reminder_time: "Bejelentkezési emlékeztető idő",
  choose_clockout_reminder_time: "Kizárási emlékeztető ideje",
  choose_break_reminder_time: "Szünethossz",
  saved_successfully: "Sikeresen mentve 👍",
  clock_reminder_channel_name: "Bélyegemlékeztetők",
  clock_reminder_channel_description: "Emlékeztetők a be- és kilépésre",
  break_reminder_title: "Még mindig szünetet tartasz? ⏰",
  break_reminder: "Megjegyzés: A szüneted még mindig megvan.",
  // Video component translations
  video_not_supported: "Az eszközöd nem támogatja a videót :/",
  video_loading_error: "Hiba videó betöltése",
  video_retry: "Újratöltés"
};